/**
 * Standard room type keys and display labels used across the app.
 */
export const roomTypeLabels: Record<string, string> = {
  single_room: 'Single Room',
  double_room: 'Double Room',
  double_twin_room: 'Double Twin Room',
  triple_room: 'Triple Room',
};

/**
 * Return a human-readable label for a room type key.
 * Falls back to the raw key with underscores replaced by spaces.
 */
export const formatRoomType = (resourceType: string | null | undefined): string => {
  if (!resourceType) {
    return '';
  }

  return roomTypeLabels[resourceType] ?? resourceType.replace(/_/g, ' ');
};
